import { Component, inject, input, output, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { GenerateIdentifierDirective } from 'src/app/directives/generate-identifier.directive';
import { MenuItemViewModel } from '../menu-grammar';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
  imports: [
    RouterLink,
    RouterLinkActive,
    MatTooltip,
    NgClass,
    GenerateIdentifierDirective,
  ],
})
export class MenuItemComponent {
  private router = inject(Router);

  item = input.required<MenuItemViewModel>();
  iconOnly = input<boolean>(false);
  selected = input<boolean>(false);

  select = output<MenuItemViewModel>();

  isOpen = signal(false);

  toggleChildren() {
    this.isOpen.update((v) => !v);
  }

  onClick() {
    const item = this.item();
    if (item.children?.length) {
      this.toggleChildren();
      return;
    }
    if (item.locked && item.lockedUrl) {
      this.router.navigateByUrl(item.lockedUrl);
      return;
    }
    this.select.emit(item);
  }
}
